import { RuntimeFrameworkService } from '../rtf-service';
import { UID } from '@farris/devkit';

export class MessagePipe {
    constructor(public token: string, private rtfService: RuntimeFrameworkService) { }
    /**
     * åç®¡éåéæ¶æ¯
     * @param message æ¶æ¯
     */
    public sendMessage(message: any) {
        this.rtfService.subjectNotify(this.token, message);
        return this;
    }
    /**
     * çå¬ç®¡éæ¶æ¯
     * @param handler æ¶æ¯å¤çå¨
     */
    public listen(handler: (data: any) => void): () => void {
        const observerToken = UID.create();
        this.rtfService.subjectResponse(this.token, handler, observerToken);
        const unListen = () => {
            this.rtfService.responseUnSubscribe(this.token, observerToken);
        };
        return unListen;
    }
    /**
     * éæ¯ç®¡é
     */
    public destory() {
        this.rtfService.subjectRemove(this.token);
    }
}
